import { TextField } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../../../components";
import { SchoolCandidateRemark } from "../../../models/SchoolCandidate";

interface SchoolCandidateRemarksProps {
  remarks?: SchoolCandidateRemark[];
}

export function SchoolCandidateRemarks({
  remarks,
}: SchoolCandidateRemarksProps) {
  const { t } = useTranslation();

  if (!remarks?.length) return null;

  return (
    <FormCard cardTitle={t("common.schoolCandidateModel.schoolNote")}>
      <Row>
        <Col md={12}>
          {remarks.map((remark, index) => {
            const shouldDisplaySeparator = index < remarks.length - 1;

            return (
              <div key={index}>
                <div className="mb-3">
                  <TextField
                    label={hrDate(new Date(remark.dateCreated))}
                    value={remark.remark ?? ""}
                    readonly
                    plaintext
                  />
                </div>
                {shouldDisplaySeparator && <hr className="mb-3" />}
              </div>
            );
          })}
        </Col>
      </Row>
    </FormCard>
  );
}
